import { createContext } from 'react'

export const ContextLoader = createContext()
export const TransitionContext = createContext({
  transition: 'default',
  setTransition: () => {}
})